const misc = {
  SOURCE: 'business-portal',
}

export default misc
